<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">Detail Contact Subject</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="row">
        <div class="col">
          <label for="contactSubjectId">ID</label>
          <input
            id="contactSubjectId"
            type="text"
            v-model="form.id"
            class="form-control"
            disabled
          />
        </div>
        <div class="col">
          <label for="displayOrder">Display Order</label>
          <NumberInput input-id="displayOrder" v-model="form.displayOrder"/>
        </div>
      </div>
      <div class="d-flex flex-row my-4">
        <input
          id="flexCheckDefault"
          class="form-check-input mr-2"
          type="checkbox"
          v-model="form.isActive"
          :class="{
            'input--error': isSubmit && error.errorStatus,
          }"
        />
        <label class="form-check-label" for="flexCheckDefault"> Active </label>
        <div v-if="isSubmit && error.errorStatus" class="text-error">
          {{ error.errorStatus.message }}
        </div>
      </div>
      <p class="label-title">Contact information</p>
      <div class="row">
        <div class="col">
          <label for="subjectEn">Subject (EN)*</label>
          <input
            id="subjectEn"
            type="text"
            v-model="form.subjectEn"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorSubjectEn,
            }"
          />
          <div v-if="isSubmit && error.errorSubjectEn" class="text-error">
            {{ error.errorSubjectEn.message }}
          </div>
        </div>
        <div class="col">
          <label for="subjectTh">Subject (TH)*</label>
          <input
            id="subjectTh"
            type="text"
            v-model="form.subjectTh"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorSubjectTh,
            }"
          />
          <div v-if="isSubmit && error.errorSubjectTh" class="text-error">
            {{ error.errorSubjectTh.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="companyEmail">Company Email</label>
          <input
            id="companyEmail"
            type="text"
            v-model="form.companyEmail"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorCompanyEmail,
            }"
          />
          <div v-if="isSubmit && error.errorCompanyEmail" class="text-error">
            {{ error.errorCompanyEmail.message }}
          </div>
        </div>
      </div>
      <p class="my-5">
        Contact Info* - ระบุ email addresses โดยใช้ comma คั่น กรณีที่มีมากกว่า
        1 อีเมล ได้แก่ marketing@shiseido.co.th, support@shiseido.co.th
      </p>
      <div v-for="contact in form.contactInfo" :key="contact.code">
        <div class="row">
          <div class="col-3 label">{{ contact.name }}</div>
          <div class="col input-text">
            <input
              type="text"
              v-model="contact.emails"
              class="form-control"
              :class="{
                'input--error':
                  isSubmit && checkContactInfoErrorExist(contact),
              }"
            />
            <div v-if="isSubmit">
              <div
                v-for="errorContact in error.errorContactInfo"
                :key="errorContact.brand"
              >
                <div
                  v-if="errorContact.brand === contact.code"
                  class="text-error"
                >
                  {{ errorContact.message }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <router-link
          :to="{ name: 'ContactSubjects' }"
          class="btn btn-outline-danger btn-cancel"
          >Cancel</router-link
        >
        <button class="btn btn-outline-success ml-10" @click="onSubmit">
          Save
        </button>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog px-3">
        <h3>{{ message }}</h3>
        <div class="text-center">
          <div v-if="showSuccess && contactSubjectId" class="pb-5">
            <button class="btn-back" @click="setDefault">ตกลง</button>
          </div>
          <div v-if="showSuccess">
            <button
              class="btn-back"
              @click="() => $router.push({ name: 'ContactSubjects' })">
              กลับสู่หน้าหลัก
            </button>
          </div>
          <button
            v-if="!showSuccess"
            class="btn-back"
            @click="showDialog = false">
            ปิด
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import BrandService from "@/services/api/brand.service";
import ContactService from "@/services/api/contact.service";
import NumberInput from "components/NumberInput/NumberInput.vue";

export default {
  components: {NumberInput},
  data() {
    const query = this.$route.query;
    const id = query.contactSubjectId;
    return {
      contactSubjectId: id,
      message: "",
      showSuccess: false,
      showDialog: false,
      isLoading: false,
      isSubmit: false,
      contactInfo: [],
      form: {
        id: null,
        displayOrder: 0,
        subjectEn: "",
        subjectTh: "",
        companyEmail: "",
        dateCreated: null,
        lastUpdated: null,
        isActive: true,
        contactInfo: [],
      },
      error: {
        errorSubjectTh: null,
        errorSubjectEn: null,
        errorCompanyEmail: null,
        errorContactInfo: [],
        errorStatus: null,
      },
    };
  },
  mounted() {
    if (this.contactSubjectId) {
      this.bindingData();
    } else {
      this.getListBrands();
    }
  },
  methods: {
    async getListBrands(list) {
      this.isLoading = true;
      try {
        const param = {
          status: "ACTIVE"
        };

        await BrandService.getListBrands(param)
          .then((res) => {
            this.isLoading = false;
            if (list) {
              this.form.contactInfo = res.data.brand.map((b) => {
                const contact = list.find((l) => l.code === b.code);
                return {
                  code: b.code,
                  name: b.name,
                  emails: contact.emails || "",
                };
              });
            } else {
              this.form.contactInfo = res.data.brand.map((i) => {
                return {
                  code: i.code,
                  name: i.name,
                };
              });
            }
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    async bindingData() {
      this.isLoading = true;
      try {
        await ContactService.getDetailContactSubject(this.contactSubjectId)
          .then(async (res) => {
            this.isLoading = false;
            const data = res.data.contactSubjects;
            this.form = {
              id: this.contactSubjectId,
              displayOrder: data.displayOrder,
              subjectEn: data.subjectEn,
              subjectTh: data.subjectTh,
              dateCreated: data.dateCreated,
              lastUpdated: data.lastUpdated,
              isActive: data.status === "ACTIVE",
              companyEmail: data.companyEmail,
            };
            await this.getListBrands(data.contactInfo);
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    async addOrEditContactSubject(body, isUpdate = false) {
      this.isLoading = true;
      try {
        await ContactService.createOrUpdateContactSubject(
          body,
          this.contactSubjectId,
          isUpdate
        )
          .then((res) => {
            const data = res.data;
            this.isLoading = false;

            if (data.status === "failure") {
              this.setErrorText(data.errors);
              if (data.message) {
                this.message = data.message;
                this.showDialog = true;
              }
            } else {
              this.message = "Saved Successfully";
              this.showDialog = true;
              this.showSuccess = true;
            }
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    onSubmit() {
      const form = this.form;
      this.isSubmit = true;
      this.showSuccess = false;
      const body = {
        subjectTh: form.subjectTh,
        subjectEn: form.subjectEn,
        companyEmail: form.companyEmail,
        displayOrder: form.displayOrder,
        status: form.isActive ? "ACTIVE" : "INACTIVE",
        contactInfo: form.contactInfo,
      };
      let query = this.$route.query;
      if (query?.contactSubjectId) {
        this.addOrEditContactSubject(body, true);
      } else {
        body.brandCode = form.brandCode;
        this.addOrEditContactSubject(body);
      }
    },
    setErrorText(errors) {
      this.error.errorSubjectTh = errors.find(
        (e) => e.field_name === "subjectTh"
      );
      this.error.errorSubjectEn = errors.find(
        (e) => e.field_name === "subjectEn"
      );
      this.error.errorCompanyEmail = errors.find(
        (e) => e.field_name === "companyEmail"
      );
      this.error.errorContactInfo = errors.filter(
        (e) => e.field_name === "contactInfo"
      );
      this.error.errorStatus = errors.find((e) => e.field_name === "status");
    },
    checkContactInfoErrorExist(contact) {
      return this.error.errorContactInfo.find((e) => e.brand === contact.code);
    },
    setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.label-title {
  font-weight: 900;
}

.btn {
  margin: 3rem 0;
}

.btn-cancel {
  color: red;

  .btn-cancel:hover {
    color: white;
  }
}

.text-error {
  color: red;
  font-size: 12px;
}
.content-dialog {
  height: 300px;
  background: #fff;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }
  .btn-back:hover {
    text-decoration: underline;
  }
}
</style>
